/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Heart",
  size: 20
}

const SvgHeart = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      strokeWidth={1.03}
      d="M10 4S8.1 2 5.74 2 1 3.55 1 6.73c0 2.11 1.67 3.71 1.67 3.71L10 18l7.33-7.56S19 8.84 19 6.73C19 3.55 16.62 2 14.26 2 11.9 2 10 4 10 4h0z"
    />
  </Svg>
)

SvgHeart.defaultProps = defaultProps
export default SvgHeart
